import { ReportAttributes, ReportRelationships } from 'dashboard/models/report';
import { BusinessLookupEdgeResult } from 'dashboard/models/report/business-lookup-result-edge';
import { ApiModel, ApiResource } from 'lib/interfaces/api';

export enum MatchStatus {
  NotApplicable = 'not_applicable',
  Match = 'match',
  PartialMatch = 'partial_match',
  NoMatch = 'no_match',
  Unavailable = 'unavailable',
  Unknown = 'unknown',
}

export interface BusinessAddress {
  'delivery-point-barcode'?: string;
  'street-1': string;
  'street-2'?: string | null;
  'street-name'?: string;
  city: string;
  subdivision: string;
  'postal-code': string;
  'primary-number'?: string;
  latitude?: number;
  longitude?: number;
}

export interface AssociatedPerson {
  'name-full': string;
  'name-first'?: string;
  'name-last'?: string;
  titles?: string[];
}

export interface BusinessRegistration {
  state?: string;
  'issue-date'?: string;
  'file-number'?: string;
  status?: string;
}

export interface ReportBusinessLookupAttributes extends ReportAttributes {
  query?: {
    'business-name'?: string;
    'address-street-1'?: string;
    'address-street-2'?: string;
    'address-city'?: string;
    'address-subdivision'?: string;
    'address-postal-code'?: string;
    'phone-number'?: string;
    ein?: string;
    website?: string;
    'associated-people'?: AssociatedPerson[];
  };
  result?: BusinessLookupEdgeResult;
  'normalized-business-name'?: string;
  'normalized-address-street-1'?: string;
  'normalized-address-street-2'?: string;
  'normalized-address-city'?: string;
  'normalized-address-subdivision'?: string;
  'normalized-address-postal-code'?: string;
  'normalized-phone-number'?: string;
  'normalized-ein'?: string;

  // overall computed signal
  'match-status-strength'?: MatchStatus;

  // computed signals
  'match-status-business-name'?: MatchStatus;
  'match-status-address'?: MatchStatus;
  'match-status-associated-person'?: MatchStatus;

  // raw signals
  'match-status-address-street'?: MatchStatus;
  'match-status-address-city'?: MatchStatus;
  'match-status-address-subdivision'?: MatchStatus;
  'match-status-address-postal-code'?: MatchStatus;
  'match-status-phone-number'?: MatchStatus;
  'match-status-website'?: MatchStatus;

  // DEPRECATED
  'match-status-ein'?: MatchStatus;
}

export type ReportBusinessLookup = ApiResource<
  ReportBusinessLookupAttributes,
  ReportRelationships,
  ApiModel.ReportBusinessLookup
>;
